import React, {Component} from "react";
import PropTypes from "prop-types";

class NoResult extends Component {
    render() {
        const {term, loading} = this.props;

        if (loading) {
            return (
                <div className="NoResult text-center">
                    Loading...
                </div>
            );
        }

        if (!term) {
            return null;
        }

        return (
            <div className="NoResult text-center">
                No result.
            </div>
        );
    }
}

NoResult.propsTypes = {
    term: PropTypes.string
};

NoResult.defaultProps = {
    loading: false
};

export default NoResult;


// WEBPACK FOOTER //
// ./src/app/home/NoResult.js